import React from 'react'
import {
  CodeXml, FileText, LayoutDashboard, Megaphone, MousePointerClick, ShoppingBag, ShoppingCart,
} from 'lucide-react'

const ICONS = {
  overview: LayoutDashboard,
  api: CodeXml,
  clicks: MousePointerClick,
  purchases: ShoppingCart,
  statement: FileText,
}

// Anchors to the sections on this same page, only for the ones the partner
// has (workspaceSections() in model.js). Below them, ways out to the
// campaign lists the old landing view used to show inline.
export default function WorkspaceSidebar({ sections, partnerName, onOpenCampaigns, onOpenBuyer }) {
  return (
    <aside className="pw-sidebar" aria-label="Partner workspace">
      <div className="pw-title" style={{ fontSize: 18, fontWeight: 800, letterSpacing: -0.3, padding: '0 10px' }}>
        Kickoff
      </div>

      <nav className="pw-nav" aria-label="Sections">
        {sections.map((s) => {
          const Icon = ICONS[s.icon] || LayoutDashboard
          return (
            <a key={s.id} href={`#${s.id}`} onClick={(e) => jumpTo(e, s.id)}>
              <Icon size={15} aria-hidden="true" />
              {s.label}
            </a>
          )
        })}
      </nav>

      {(onOpenCampaigns || onOpenBuyer) && (
        <nav className="pw-nav pw-sidebar-extra" aria-label="Campaigns" style={{ borderTop: '1px solid var(--border)', paddingTop: 12 }}>
          {onOpenCampaigns && (
            <button type="button" onClick={onOpenCampaigns}>
              <Megaphone size={15} aria-hidden="true" /> Your campaigns
            </button>
          )}
          {onOpenBuyer && (
            <button type="button" onClick={onOpenBuyer}>
              <ShoppingBag size={15} aria-hidden="true" /> Leads you bought
            </button>
          )}
        </nav>
      )}

      {partnerName && (
        <div className="pw-sidebar-extra" style={{
          marginTop: 'auto', display: 'flex', alignItems: 'center', gap: 10,
          padding: 10, borderRadius: 12, background: 'var(--bg-raised)',
        }}>
          <span aria-hidden="true" style={{
            width: 30, height: 30, borderRadius: 9, flexShrink: 0,
            display: 'grid', placeItems: 'center', fontWeight: 700, fontSize: 12,
            background: 'var(--accent-soft)', color: 'var(--accent)',
          }}>
            {initials(partnerName)}
          </span>
          <span style={{ minWidth: 0, display: 'flex', flexDirection: 'column' }}>
            <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-primary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {partnerName}
            </span>
            <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>Partner account</span>
          </span>
        </div>
      )}
    </aside>
  )
}

// The page scrolls inside Layout's .page-content, not the window, so the
// browser's own hash jump is replaced by scrollIntoView on the section.
function jumpTo(event, id) {
  const target = document.getElementById(id)
  if (!target) return
  event.preventDefault()
  const smooth = !window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' })
}

function initials(name) {
  return String(name).split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join('')
}
